import { getMrsConnectedAccounts } from '../services/getMrsConnectedAccounts';
import { resetConnectedFullStore } from '../actions/connectedFull/resetConnectedFullStore';

export async function loadMrsConnectedAccounts(): Promise<void> {
    let response = await getMrsConnectedAccounts();
    resetConnectedFullStore(response.ErrorMessage ? null : response.ConnectedAccountsInformation);
}
